import { render, staticRenderFns } from "./ElectricalCauseOriginQuestion.vue?vue&type=template&id=d5d6b0c0"
import script from "./ElectricalCauseOriginQuestion.vue?vue&type=script&lang=ts"
export * from "./ElectricalCauseOriginQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports